export default {
  title: 'Nyt brand',
  tabs: {
    general: 'Generelt',
    branding: 'Branding',
    scripts: 'Scripts',
    tracking: 'Tracking',
    domain: 'Domæne',
  },
  fields: {
    name: {
      label: 'Navn',
      placeholder: 'Brandnavn',
    },
    slug: {
      label: 'Subdomæne',
      placeholder: 'Brandets subdomæne',
      hint: 'Små bogstaver, tal og bindestreger. Sammen med shoppens domæne danner det shoppens adresse.',
      preview: 'Shopadresse: {{url}}',
      availability: {
        taken: 'Et andet brand bruger allerede dette subdomæne på dette shopdomæne.',
        reserved: 'Dette subdomæne er reserveret. Vælg et andet.',
        invalid_label:
          'På dette shopdomæne må subdomænet kun bestå af små bogstaver, tal og bindestreger, skal starte og slutte med et bogstav eller tal og må højst være 63 tegn langt.',
        taken_elsewhere: 'Et brand på et andet shopdomæne bruger allerede dette subdomæne. Vælg et andet.',
        format: 'Brug kun bogstaver, tal, bindestreger og understregninger.',
        unavailable: 'Dette subdomæne er ikke tilgængeligt. Vælg et andet.',
      },
    },
    shop_domain_id: {
      label: 'Shopdomæne',
      placeholder: 'Vælg et shopdomæne',
      move_warning: {
        title: 'Dette ændrer den shopadresse, kunderne bruger',
        description:
          'Efter gemning findes shoppen på {{url}}. QR-koder, flyers og links, der allerede er trykt eller delt med den gamle adresse, holder op med at virke.',
      },
    },
    lieferando_url: {
      label: 'Lieferando-URL',
      placeholder: 'Restaurantens URL på Lieferando',
    },
    primary_color: {
      label: 'Primær farve',
    },
    logo: {
      label: 'Logo',
    },
    image: {
      label: 'Billede',
    },
    companies: {
      label: 'Restauranter',
    },
    noscripts: {
      description: 'Indsæt kode lige efter åbningen af body',
    },
    facebook_pixel: {
      label: 'Facebook Pixel',
    },
    facebook_conversion_api_access_token: {
      label: 'Facebook Conversion-adgangstoken',
    },
    google_analytics_id: {
      label: 'Google Analytics-ID',
    },
    google_ads_conversion_label_id: {
      label: 'Google Ads-konverteringsetiket',
    },
    // Named in the modal's error summary when the domain is refused.
    online_shop_domain: {
      label: 'Eget domæne til onlineshoppen',
    },
  },
  buttons: {
    save: 'Gem',
    close: 'Luk',
    sync_from_lieferando: 'Synkroniser fra Lieferando',
  },
  toasts: {
    changes_saved_successfully: 'Ændringerne er gemt!',
    failed_to_update_company_slug: 'Kunne ikke opdatere slug for {{name}}',
    failed_to_sync_lieferando: 'Kunne ikke synkronisere oplysninger fra Lieferando',
    successfully_synced_lieferando: 'Data er synkroniseret fra Lieferando',
    failed_to_load_shop_domains: 'Shopdomænerne kunne ikke indlæses.',
  },
};
